import { render, staticRenderFns } from "./configModule.vue?vue&type=template&id=0522a954&scoped=true&"
import script from "./configModule.vue?vue&type=script&lang=js&"
export * from "./configModule.vue?vue&type=script&lang=js&"
import style0 from "./configModule.vue?vue&type=style&index=0&id=0522a954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522a954",
  null
  
)

export default component.exports